import { useEffect } from 'react';
import SubItems from "./Components/Submenu/SubItems";
import Sidebar from "./Components/Sidebar";
import { useGlobalState } from "./Provider/AppProvider";
import Main from "./Components/Main";
import Messages from "./Components/Messages";
import ListCertificates from "./Components/ListCertificates";
import WaitingList from "./Components/WaitingList";
import Login from "./Components/Login";


function App() {
    const { sidebarFull, darkMode, showSidebar, navbarSubmenu: { visible }, hideNavbarSubmenu, displaySidebar, hideSidebar, activeView, isAuthenticated, isAuthChecking, login } = useGlobalState();

    const handleClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        if (!visible) return;

        const elements = [...document.querySelectorAll('.clicked') as NodeListOf<HTMLElement>];
        for (let i = 0; i < elements.length; i++) {
            const element = elements[i] as any;
            if (element === e.target || element.contains(e.target)) {
                return;
            }
        }
        hideNavbarSubmenu();
    }

    // Show loading while validating token on app load
    if (isAuthChecking) {
        return (
            <div className="App" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
                <span style={{ fontSize: '18px' }}>Loading...</span>
            </div>
        );
    }

    // Show login page if not authenticated
    if (!isAuthenticated && window.location.pathname !== '/login') {
        window.location.href = '/login';
        return null;
    }

    // If on login path and not authenticated, show login
    if (window.location.pathname === '/login' && !isAuthenticated) {
        return <Login onLogin={login} />;
    }

    // If on login path but authenticated, redirect to home
    if (window.location.pathname === '/login' && isAuthenticated) {
        window.location.href = '/';
        return null; // Don't render while redirecting
    }

    return (
        <div 
            className={`App${darkMode ? " dark" : ""}`}
            onClick={handleClick}
        >
            <div className={`app-wrapper${!sidebarFull ? ' hidden-side-bar' : ''}`}>
                <Sidebar />
                <div>
                    {activeView === 'Home' && <Main  />}
                    {activeView === 'Messages' && <Messages />}
                    {activeView === 'List Certificate' && <ListCertificates />}
                    {activeView === 'Issue Certificate' && <ListCertificates openIssue />}
                    {activeView === 'Waiting List' && <WaitingList />}

                </div>
            </div>
            {/* <SubItems /> */}
            <button onClick={displaySidebar} className="show-sidebar-btn">Menu</button>
            <div onClick={hideSidebar} className={`overlay${showSidebar ? " show" : ""}`} />
        </div>
    );
}

export default App;
